/**
 * theme/motion.ts
 * The design has two animations and no others:
 *   skfade  — 180–240ms ease-out, opacity 0→1 with a 6px rise (modals,
 *             drawer content, onboarding, empty states)
 *   skslide — 200ms ease-out, translateX 16px→0 (the drawer panel)
 * Durations live here so a reduced-motion setting can zero them in one place.
 */
import { Easing } from 'react-native';

export const duration = {
  fadeFast: 180,
  fade: 200,
  fadeSlow: 240,
  slide: 200,
} as const;

/** ease-out — the only curve in the design. */
export const easing = Easing.out(Easing.cubic);

/** Translate distances for the two entrances. */
export const offset = { fadeY: 6, slideX: 16 } as const;

export const motion = { duration, easing, offset } as const;
